var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstalment1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27137",
    "data-name": "Group 27137",
    transform: "translate(-42 -772)"
  }, /*#__PURE__*/React.createElement("text", {
    id: "_1",
    "data-name": 1,
    transform: "translate(56 789.947)",
    fill: "#dedede",
    fontSize: 12,
    fontFamily: "Red Hat Display",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -2.694,
    y: 0
  }, "1")), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_177",
    "data-name": "Ellipse 177",
    transform: "translate(42 772)",
    fill: "none",
    stroke: "#dedede",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 14,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 13,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstalment1);
export default __webpack_public_path__ + "static/media/instalment-1.037436d5c9e81900f63585c52f5c5e62.svg";
export { ForwardRef as ReactComponent };